import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'google_map_url',
    label: 'Google Map URL',
    type: types.TEXT
  },
  {
    key: 'ratio',
    label: 'Ratio',
    type: types.TEXT
  }
];

const defaultProps = {
  google_map_url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3134.2994136407788!2d-118.28418370061934!3d33.86360773633031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2caba07ae2503%3A0x1daaac6f07a3ae8c!2s18455+S+Figueroa+St%2C+Gardena%2C+CA+90248!5e0!3',
  ratio: '4:1'
};

export default {
  title: 'Google Map',
  id: 'GoogleMap',
  widgetImage: '/widgetImages/Google+map.png',
  basic: true,
  propsSchema,
  defaultProps
};
